function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21 6.925V19.5c0 .4-.15.75-.45 1.05-.3.3-.65.45-1.05.45h-15c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05v-15c0-.4.15-.75.45-1.05.3-.3.65-.45 1.05-.45h12.575L21 6.925zm-1.5.675l-3.1-3.1H4.5v15h15V7.6zm-7.506 10.275c.72 0 1.335-.252 1.844-.757a2.492 2.492 0 00.762-1.837c0-.72-.252-1.335-.757-1.844a2.492 2.492 0 00-1.837-.762c-.72 0-1.335.252-1.844.757a2.492 2.492 0 00-.762 1.837c0 .72.252 1.335.757 1.844a2.492 2.492 0 001.837.762zM5.825 9.4h8.95V5.825h-8.95V9.4zM4.5 7.6v11.9-15 3.1z",
  fill: "#474747"
})));